module.exports = __webpack_public_path__ + "img/78e399d.jpg";